module.exports = __webpack_public_path__ + "static/media/delfos_Intelligent_maintenance.1410cf34.png";